import React, { useCallback, useState, useMemo, useEffect } from "react";
import { useDropzone } from "react-dropzone";

import "../styles/DropZone.css";

const acceptStyle = {
  borderColor: "#8fddeb",
};

const readyStyle = {
  borderColor: "#b0ff8f",
};

const DropZone = ({
  label,
  setFileData,
  width,
  height,
  originalFile,
  hideTopLabel,
  coachingPoint = false,
  coachingPointFileExists,
  fileName,
  updateFileName,
}) => {
  const outerWidth = `${width + 30}px`;

  const outerHeight = `${height + 30}px`;

  const baseStyle = {
    padding: "10px",
    width: outerWidth,
    height: outerHeight,
    borderColor: "#ddd",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const previewStyle = {
    width: width,
    height: height,
  };

  const [imgFile, setImgFile] = useState();
  const [isFileReady, setFileReady] = useState(false);
  const [filePreview, setFilePreview] = useState();

  useEffect(() => {
    if (originalFile) {
      setFileReady(true);
      setFilePreview(originalFile);
      // setImgFile();
    }
  }, [originalFile]);

  const onDrop = useCallback((acceptedFiles) => {
    console.log("accepted file: " + JSON.stringify(acceptedFiles[0].path));
    if (coachingPoint) updateFileName(String(acceptedFiles[0].path));
    setFileReady(true);
    setImgFile(acceptedFiles[0]);
    uploadFile(acceptedFiles[0]);
    setFilePreview(URL.createObjectURL(acceptedFiles[0]));
  }, []);

  const { getRootProps, getInputProps, isDragAccept, isDragActive } = useDropzone({ onDrop });

  const uploadFile = (file) => {
    if (file) {
      const data = new FormData();
      data.append("file", file);

      setFileData(data);
    }
  };

  useEffect(() => {
    uploadFile(imgFile);
  }, [imgFile]);

  // useEffect(() => {
  //   console.log("Dropzone filename:", fileName);
  //   setLocalFileName(fileName);
  // }, [fileName]);

  const style = useMemo(
    () =>
      coachingPoint
        ? {
          ...baseStyle,
          ...(isDragAccept ? acceptStyle : {}),
          ...(coachingPointFileExists ? readyStyle : {}),
        }
        : {
          ...baseStyle,
          ...(isDragAccept ? acceptStyle : {}),
          ...(isFileReady ? readyStyle : {}),
        },
    [isDragAccept, isFileReady, coachingPointFileExists]
  );

  return (
    <div className="dropzone-container">
      {/* <input type="file" name="file" onChange={uploadHandler} /> */}
      {!hideTopLabel && <p>{label}</p>}
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />
        {!coachingPoint &&
          (isFileReady ? (
            <div className="dropzone-inner">
              <img key="2" alt={fileName} src={filePreview} style={previewStyle} />
            </div>
          ) : (
            [
              isDragActive ? (
                <p key="1" style={{ margin: 0 }}>
                  Drop Me!
                </p>
              ) : (
                <p key="0" style={{ margin: 0 }}>
                  {label}
                </p>
              ),
            ]
          ))}
        {
          // if this is the dropzones in the coaching points menu, use text instead of an image
          coachingPoint && (
            <>
              {isFileReady ? (
                <div className="dropzone-inner">
                  <p>{fileName}</p>
                </div>
              ) : (
                [
                  isDragActive ? (
                    <p key="1" style={{ margin: 0 }}>
                      Drop Me!
                    </p>
                  ) : (
                    <p key="0" style={{ margin: 0 }}>
                      {label}
                    </p>
                  ),
                ]
              )}
            </>
          )
        }
      </div>
    </div>
  );
};

export default DropZone;

// COMMENTED OUT BECAUSE UNUSED. DO WE NEED THIS?

// function blobCreationFromURL(inputURI) {
//   var binaryVal;

//   // mime extension extraction
//   var inputMIME = inputURI.split(",")[0].split(":")[1].split(";")[0];

//   // Extract remaining part of URL and convert it to binary value
//   if (inputURI.split(",")[0].indexOf("base64") >= 0)
//     binaryVal = atob(inputURI.split(",")[1]);
//   // Decoding of base64 encoded string
//   else binaryVal = unescape(inputURI.split(",")[1]);

//   // Computation of new string in which hexadecimal
//   // escape sequences are replaced by the character
//   // it represents

//   // Store the bytes of the string to a typed array
//   var blobArray = [];
//   for (var index = 0; index < binaryVal.length; index++) {
//     blobArray.push(binaryVal.charCodeAt(index));
//   }

//   return new Blob([blobArray], {
//     type: inputMIME,
//   });
// }
